import React, { useState } from 'react';
import { Typography, Card, CardContent, Grid } from "@mui/material";
import As2CommStatusSearchComponent from './search-component';
import As2CommStatusSummaryTable from './as2-summary-table/As2CommStatusSummaryTable.js';
import As2DetailForm from './as2-detail-form/As2DetailForm';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

const gridStyles = {
    height: "100%"
};



export const MainView = () => {
    const [as2CommStatusDetails, setAs2CommStatusDetails] = useState({
        "id": undefined,
        "messageId": "",
        "direction": "",
        "senderAs2Id": "",
        "receiverAs2Id": "",
        "supplierNum": "",
        "unit": "",
        "evenlopeKey": "",
        "archivePath": "",
        "createDateTime": "",
        "as2Status": "",
        "mdnMessageId": "",
        "mdnAck": "",
        "mdnTransStatus": "",
        "updateDateTime": "",
        "formattedCreatedDateTime": "",
        "directionLabel": "",
        "asStatusAsNumber": undefined
    });

   

    return (
        <div  className="MuiBox-root" style={{ width: '100%'}}>
            <Box sx={{ width: '100%', display: 'flex', p: 1, borderRadius: 1  }}>

            <Box component="section" sx={{ flexBasis: 'min-content', flexShrink: 0, mr: 2 ,  p: 2, bgcolor: 'background.paper' }}>
                <As2CommStatusSearchComponent />
            </Box>


            <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0  }}>

                <Box sx={{ minWidth: '1000px', width: '100%' }}>
                    <As2CommStatusSummaryTable handlerDetails={setAs2CommStatusDetails} />
                </Box>




                <Box sx={{ minWidth: '1000px', width: '100%', bgcolor: 'background.paper', mt: 2, p:2  }}>
                    <As2DetailForm details={as2CommStatusDetails} />

                </Box>
            </Box>
            </Box>
        </div>



    );

}
